import React from "react";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import { ReactComponent as Chevron } from "../../assets/icons/chevron-left.svg";
import { ReactComponent as Calendar } from "../../assets/icons/Calendar.svg";
import Button from "../../Components/Common/Button";
import { useHistory } from "react-router-dom";
const moment = require("moment-jalaali");
moment.loadPersian({ dialect: "persian-modern" });
const data = [
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 1, created_at: moment() },
  { id: 1, title: "مشکل در پرداخت قبض", status: 2, created_at: moment() },
];

function Tickets() {
  const history = useHistory();
  const findStatus = (status) => {
    let text = "";
    switch (status) {
      case 1:
        text = "در انتظار پاسخ گویی پشتیبان";
        break;
      case 2:
        text = "پشتیبان به شما پاسخ داده است";
        break;

      default:
        text = "در انتظار پاسخ گویی پشتیبان";
        break;
    }
    return text;
  };
  return (
    <div className="Container" id="Container">
      <div
        className="mobileContainer"
        style={{
          paddingTop: window.innerHeight * 0.15,
          overflowY: "scroll",
          paddingBottom: window.innerHeight * 0.15,
        }}
      >
        <PhoneHeader text={"لیست تیکت‌ها"} />
        {data?.map((item) => {
          return (
            <div
              className="TicketsComponent"
              onClick={() =>
                history.push({ pathname: "TicketSingle", state: item })
              }
            >
              <div className="SpaceDiv">
                <span>{item?.title}</span>
                <Chevron />
              </div>
              <div className="grayDivider" />
              <div className="SpaceDiv">
                <span className="dateSpan">{findStatus(item?.status)}</span>
                <div className="StartDiv">
                  <Calendar />
                  <span className="dateSpan" style={{ marginRight: 5 }}>
                    {moment(item?.created_at).format("jYYYY/jMM/jDD")}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
        <Button
          title="ثبت تیکت جدید"
          onClick={() => history.push("NewTicket")}
        />
      </div>
    </div>
  );
}

export default Tickets;
